/**
 * Copyright (c) 2019 Burst Apps Team
 */

/**
 * @internal
 * @ignore
 *
 * Size of Code Pages in bytes
 *
 */
export const CodePageSize = 256;
